import React, { useCallback } from 'react';
import Contrast from '@uber/base-icons/contrast';
import useAnalyticsFoStageToolBar from '../../../labelling/components/stage-toolbar/analytics/useAnalyticsForStageToolBar';
import { useImageSettings } from '../../hooks/use-image-settings';
import { CONTROL_TYPES } from './constants';
import SliderControl from './slider-control';
export const CONTRAST_SELECTOR_ID = 'contrast-button';
function ContrastControl() {
  const [imageSettings, setImageSettings] = useImageSettings();
  const {
    contrast
  } = imageSettings;
  const {
    sendEventChangeControls
  } = useAnalyticsFoStageToolBar();
  const onFinalChange = useCallback((value: number) => {
    sendEventChangeControls({
      action: CONTROL_TYPES.CONTRAST,
      value: value.toString()
    });
  }, [sendEventChangeControls]);
  const onChange = (newValue: number) => {
    setImageSettings({
      ...imageSettings,
      contrast: newValue
    });
  };
  return <SliderControl sliderMax={200} sliderMin={0} title="Contrast" value={contrast} onChange={onChange} onFinalChange={onFinalChange} attributes={{
    'data-selector-id': CONTRAST_SELECTOR_ID,
    'data-e2e-id': CONTRAST_SELECTOR_ID
  }}>
      <Contrast title="Contrast" />
    </SliderControl>;
}
export default ContrastControl;